export default __webpack_public_path__ + "static/Principle-vendor-2e2ba45401601752047670f01e1ce727.png";